import attrToBool from '../utils/attrToBool';
import $ from '../utils/jquery';

const $toggle = $( '[data-toggle="accordion"]' );
const panelStatus = {
	open: 'expanded',
	closed: 'collapsed',
	opening: 'expanding',
	closing: 'collapsing'
};

const getCollapseWrapper = $panel => {
	return $panel.find( '[data-accordion="collapse"]' );
};

const getToggleBtn = $panel => {
	return $panel.find( '[data-toggle="accordion"]' );
};

const toggle = $panel => {
	if ( $panel.hasClass( 'animating' ) ) {
		return;
	}

	const $wrapper = getCollapseWrapper( $panel );

	if ( $wrapper.hasClass( panelStatus.open ) ) {
		closePanel( $panel );
	}

	if ( $wrapper.hasClass( panelStatus.closed ) ) {
		openPanel( $panel );
	}
};

const closeOpenedPanel = $accordion => {
	const $openedToggle = $accordion.find( '[data-toggle="accordion"][aria-expanded="true"]' );

	$openedToggle.each( ( i, el ) => {
		const $toggleBtn = $( el );
		const $panel = $toggleBtn.parents( '[data-accordion="panel"]' );
		closePanel( $panel );
	} );
};

const closePanel = $panel => {
	const $wrapper = getCollapseWrapper( $panel );
	const $toggleBtn = getToggleBtn( $panel );
	const height = $wrapper.get( 0 ).scrollHeight;

	$panel.addClass( 'animating' );

	$toggleBtn.removeClass( 'active' );

	$wrapper
		.css( { height } )
		.removeClass( panelStatus.open )
		.addClass( panelStatus.closing )
		.animate( {
			height: 0
		}, 400, () => {
			$wrapper
				.removeClass( panelStatus.closing )
				.addClass( panelStatus.closed )
				.attr( 'style', '' );

			$panel.removeClass( 'animating' );

			$toggleBtn.attr( 'aria-expanded', 'false' );
		} );
};

const openPanel = $panel => {
	const $wrapper = getCollapseWrapper( $panel );
	const $toggleBtn = getToggleBtn( $panel );

	// If option is set to close other panels
	if ( attrToBool( $toggleBtn.attr( 'data-close' ) ) ) {
		closeOpenedPanel( $panel.parents( '[data-accordion]' ) );
	}

	$panel.addClass( 'animating' );

	$toggleBtn.addClass( 'active' );

	$wrapper
		.css( {
			display: 'block',
			height: 0
		} );

	const height = $wrapper.get( 0 ).scrollHeight;

	$wrapper
		.removeClass( panelStatus.closed )
		.addClass( panelStatus.opening )
		.animate( {
			height
		}, 400, () => {
			$wrapper
				.removeClass( panelStatus.opening )
				.addClass( panelStatus.open )
				.attr( 'style', '' );

			$panel.removeClass( 'animating' );

			$toggleBtn.attr( 'aria-expanded', 'true' );
		} );
};

const bind = () => {
	$toggle.on( 'click', e => {
		const $panel = $( e.currentTarget ).parents( '[data-accordion="panel"]' );
		toggle( $panel );
	} );
};

export default () => {
	if ( ! $toggle.length ) {
		return;
	}
	bind();
};
